import {CPSConstants} from "commonUtils/enumerations";

export const dashBoardStyle = {
  containerStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    mt: "2rem",
    mb: "2rem",
    mr: "0rem",
    ml: "0rem",
  },
  typgraphyStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontWeight: "bold",
    fontSize: CPSConstants.FONTREMTEXT,
    color: "#000000",
    opacity: "1",
  },
  paperStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    flexDirection: "column",
    height: "auto",
    boxShadow: "none",
  },
  boxBorder: {
    border: "0.063rem solid #91FA1E",
  },
  boxPadding: {
    paddingBottom: "0.313rem",
  },
};
